import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.valuation');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type EvaluationRightType = '특허/실용' | '상표' | '디자인';

interface EvaluationRequest {
    requesterName: string;
    company: string;
    contact: string;
    email: string;
    rightType: EvaluationRightType;
    registrationNumber: string;
    request: string;
    privacyAgreed: boolean;
    costAgreed: boolean;
}

interface ValuationGuideCard {
    label: string;
    title: string;
    description: string;
}

interface EvaluationHistory {
    id: string;
    receiptNo: string;
    rightType: string;
    registrationNumber: string;
    status: string;
    statusLabel: string;
    createdAt: string;
}

@Component({
    selector: 'wiz-page-valuation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.valuation/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageValuationComponent implements OnInit {
    public rightTypes: EvaluationRightType[] = ['특허/실용', '상표', '디자인'];
    public guideCards: ValuationGuideCard[] = [
        {
            label: '01',
            title: '권리 정보 접수',
            description: '권리구분과 등록번호, 요청사항만 먼저 남겨 평가 필요 범위를 확인합니다.'
        },
        {
            label: '02',
            title: '상담내용 분석',
            description: '기술분야와 난이도, 활용 목적을 검토해 평가비용과 진행 방식을 안내합니다.'
        },
        {
            label: '03',
            title: '최종 진행 결정',
            description: '안내받은 평가 범위와 비용을 확인한 뒤 진행 여부를 결정합니다.'
        }
    ];
    public request: EvaluationRequest = this.createRequest();
    public requestModalOpen: boolean = false;
    public submitted: boolean = false;
    public submitting: boolean = false;
    public receiptNo: string = '';
    public requests: EvaluationHistory[] = [];
    public requestsLoading: boolean = true;
    public requestsError: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow('/market/cases')) return;
        await this.loadRequests();
    }

    public async loadRequests() {
        this.requestsLoading = true;
        this.requestsError = '';
        await this.service.render();

        const { code, data } = await wiz.call('list_requests');
        if (code === 200) {
            this.requests = Array.isArray(data?.items) ? data.items : [];
        } else {
            this.requestsError = data?.message || '기술가치평가 신청 목록을 불러오지 못했습니다.';
        }
        this.requestsLoading = false;
        await this.service.render();
    }

    public async openRequestModal() {
        this.request = this.createRequest();
        this.requestModalOpen = true;
        await this.service.render();
    }

    public async closeRequestModal() {
        this.requestModalOpen = false;
        this.request = this.createRequest();
        this.submitting = false;
        await this.service.render();
    }

    public async toggleCostAgreement() {
        this.request.costAgreed = !this.request.costAgreed;
        await this.service.render();
    }

    public async togglePrivacyAgreement() {
        this.request.privacyAgreed = !this.request.privacyAgreed;
        await this.service.render();
    }

    public async submit() {
        if (!this.request.requesterName.trim() || !this.request.contact.trim() || !this.request.email.trim() || !this.request.registrationNumber.trim() || !this.request.request.trim()) {
            await this.service.modal.error('신청자 정보, 등록번호와 요청사항을 입력해주세요.');
            return;
        }
        if (!/^\S+@\S+\.\S+$/.test(this.request.email.trim()) || this.request.contact.replace(/\D/g, '').length < 9) {
            await this.service.modal.error('연락처와 이메일 형식을 확인해주세요.');
            return;
        }
        if (!this.request.privacyAgreed || !this.request.costAgreed) {
            await this.service.modal.error('개인정보 및 기술가치평가 비용 안내 동의가 필요합니다.');
            return;
        }

        this.submitting = true;
        await this.service.render();
        const { code, data } = await wiz.call('submit_consultation', {
            payload: JSON.stringify({
                flow: 'valuation_request',
                data: {
                    requester: { name: this.request.requesterName.trim(), company: this.request.company.trim() },
                    contact: { phone: this.request.contact.trim(), email: this.request.email.trim() },
                    privacyAgreed: this.request.privacyAgreed,
                    feeAgreed: this.request.costAgreed,
                    details: {
                        rightType: this.request.rightType,
                        registrationNumber: this.request.registrationNumber.trim(),
                        request: this.request.request.trim(),
                        costAgreed: this.request.costAgreed
                    }
                }
            })
        });
        this.submitting = false;
        if (code !== 200) {
            await this.service.modal.error(this.consultationError(data));
            await this.service.render();
            return;
        }

        this.receiptNo = data.receiptNo;
        this.submitted = true;
        this.requestModalOpen = false;
        this.request = this.createRequest();
        await this.loadRequests();
    }

    public async resetForm() {
        this.request = this.createRequest();
        this.submitted = false;
        this.receiptNo = '';
        await this.service.render();
    }

    private createRequest(): EvaluationRequest {
        return {
            requesterName: '',
            company: '',
            contact: '',
            email: '',
            rightType: '특허/실용',
            registrationNumber: '',
            request: '',
            privacyAgreed: false,
            costAgreed: false
        };
    }

    private consultationError(data: any) {
        const message = data?.message || '상담 접수에 실패했습니다.';
        if (data?.errorType === 'validation') return `입력값 오류: ${message}`;
        if (data?.errorType === 'network') return `네트워크 오류: ${message}`;
        return `서버 오류: ${message}`;
    }
}

export default PageValuationComponent;